module.exports = __webpack_public_path__ + "static/media/Logo_PICSUP_neu.420ff73f.png";